/* eslint-disable @typescript-eslint/no-explicit-any */
import VueRouter, { RawLocation } from 'vue-router';
import { ProgramState } from '~/types/types';

export class Settings {
    router: VueRouter;
    public constructor(settings: any, router: VueRouter) {
        Object.assign(this, settings);
        this.router = router;
    }
    public absoluteUrl(url: string) {
        return window.location.origin + this.url(url);
    }
    public urlFromRoute(url: RawLocation) {
        return this.url(this.router.resolve(url).href);
    }
    public absoluteUrlFromRoute(url: RawLocation) {
        return this.absoluteUrl(this.router.resolve(url).href);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    landingMenu: Array<{
        icon: [string, string] | string;
        image: string;
        title: string;
        to: string;
        exact: boolean;
        isDisabled: boolean;
        programState: ProgramState;
        isLandingMenu: boolean;
    }>;
    selectionMenu: Array<{
        icon: [string, string] | string;
        title: string;
        to: string;
        exact: boolean;
        isDisabled: boolean;
        programState: ProgramState;
    }>;
    sideBar: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    tcProgramId: string;
    patientProgramId: string;
    patientRepProgramId: string;
    hcpProgramId: string;
    pharmacyProgramId: string;
    maxPatientSearchReturn: number;
    surveyId: string;
    authAudience: string;
    authDomain: string;
    authClientId: string;
    logo: string;
    logoVemlidy: string;
    logoAdvancingAccess: string;
    lockEnabled: string;
    lockPassword: string;
    ConnectTo: string;
    templateId:string;
    brandId:string;
    senderId:string;
    expireInDays:string;
    enrollmentTypeQuestion: string;
    enrollmentTypePatient: string;
    enrollmentTypePharmacy: string;
    enrollmentTypeHCP: string;

    agreeToAuthorizeQuestion: string;
    agreeToAuthorizeAnswerYes: string;
    agreeToAuthorizeAnswerNo: string;

    patientCommercialInsuranceQuestion: string;
    patientCommercialInsuranceYes: string;
    patientCommercialInsuranceNo: string;

    patientFedralQuestion: string;
    patientFedralYes: string;
    patientFedralNo: string;

    patintPayingCashQuestion: string;
    patintPayingCashYes: string;
    patintPayingCashNo: string;

    patientCurrentTerritoryQuestion: string;
    patientCurrentTerritoryYes: string;
    patientCurrentTerritoryNo: string;

    patientAgeQuestion: string;
    patientAgeYes: string;
    patientAgeNo: string;
    caseSource: string;

    agreeToPrivacyAndTermsQuestion: string;
    agreeToPrivacyAndTermsYes: string;

    agreeToMarketingCommunicationsQuestion: string;
    agreeToMarketingCommunicationsYes: string;

    agreeToTextMessageConsentQuestion: string;
    agreeToTextMessageConsentYes: string;

    pharmacyPrescriptionSentQuestion: string;
    pharmacyPrescriptionSentYes: string;
    pharmacyPrescriptionSentNo: string;

    pharmacyNameQuestion: string;
    pharmacyNameAnswer: string;
}
